import { apiClient } from "@/lib/apiClient";

/** GET /api/admin/departments - department type: 1 CENTRAL, 2 BRANCH */
export type DepartmentType = 1 | 2;

export interface DepartmentItem {
  id: string;
  name: string;
  type?: number;
}

export interface DepartmentsListParams {
  page?: number;
  limit?: number;
  search?: string;
  type?: DepartmentType;
}

export interface DepartmentsListResponse {
  success?: boolean;
  data?: DepartmentItem[] | { items?: DepartmentItem[]; total?: number };
  items?: DepartmentItem[];
  count?: number;
  total?: number;
}

/**
 * GET /api/admin/departments - Paginated list. Query: page, limit, search, type (1=CENTRAL, 2=BRANCH).
 */
export async function fetchDepartments(
  params?: DepartmentsListParams
): Promise<DepartmentItem[]> {
  const query: Record<string, unknown> = {};
  if (params?.page != null) query.page = params.page;
  if (params?.limit != null) query.limit = params.limit;
  if (params?.search != null && params.search !== "") query.search = params.search;
  if (params?.type != null) query.type = params.type;

  const response = await apiClient.get<DepartmentsListResponse>(
    "/api/admin/departments",
    { params: query }
  );

  const data = response.data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray((data as { items?: DepartmentItem[] })?.items)) {
    return (data as { items: DepartmentItem[] }).items;
  }
  if (data?.data && typeof data.data === "object" && "items" in data.data) {
    const nested = (data.data as { items?: DepartmentItem[] }).items;
    return Array.isArray(nested) ? nested : [];
  }
  return [];
}

/**
 * GET /api/admin/departments/roots - Yalnızca kök birimler (parentID IS NULL).
 * UI dropdown'larında Merkez/Taşra altındaki en üst seviye birimleri (Daire Başkanlığı,
 * İşletme, Santral) listelemek için kullanılır.
 */
export async function fetchRootDepartments(): Promise<DepartmentItem[]> {
  const response = await apiClient.get<DepartmentsListResponse>(
    "/api/admin/departments/roots",
  );
  const data = response.data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray((data as { items?: DepartmentItem[] })?.items)) {
    return (data as { items: DepartmentItem[] }).items;
  }
  if (data?.data && typeof data.data === "object" && "items" in data.data) {
    const nested = (data.data as { items?: DepartmentItem[] }).items;
    return Array.isArray(nested) ? nested : [];
  }
  return [];
}
